import React from "react";
import { Grid, Box, useMediaQuery } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import image1 from "../assets/banner1.webp";
import image2 from "../assets/banner2.webp";
import image3 from "../assets/banner3.webp";
import image4 from "../assets/banner4.webp";

const Banner = () => {
    const data = [
        { id: 1, image: image1 },
        { id: 2, image: image2 },
        { id: 3, image: image3 },
        { id: 4, image: image4 },
    ];

    const isMobileScreen = useMediaQuery("(min-width:360px) and (max-width:500px)");
    const isSmallScreen = useMediaQuery("(min-width:1024px) and (max-width:1440px)");

    return (
        <Grid id="banner" container justifyContent="center" sx={{ mt: 8 }}>
            <Grid item xs={12}>
                <Swiper
                    modules={[Autoplay, Navigation, Pagination]}
                    autoplay={{ delay: 3000, disableOnInteraction: false }}
                    navigation
                    pagination={{ clickable: true }}
                    loop={true}
                    slidesPerView={1}
                    style={{
                        "--swiper-navigation-color": "white",
                        "--swiper-pagination-color": "white",
                    }}
                >
                    {data.map((carouselData, index) => (
                        <SwiperSlide key={index}>
                            <Box sx={{ position: "relative",mt:{md:7,xs:0},height:{xs:'150px',md:'200px'},width:{xs:'100%',md:'100%'} }}>
                                <img
                                    src={carouselData.image}
                                    alt="carouselImage"
                                    style={{
                                        width: "100%",
                                        height: "100%", 
                                        objectFit: "cover",
                                        filter: "brightness(0.8)",

                                    }}
                                    loading="lazy"
                                />
                            </Box>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Grid>
        </Grid>
    );
};

export default Banner;